module.exports = __webpack_public_path__ + "static/img/green_02_471.79c6827.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/deco/green_02_471.png
// module id = X4rf
// module chunks = 0